<template>
  <div class="shopsInfo container">
    <navBar :title="topTitle" />
    <div class="infoBox">
      <div class="item flexBetween">
        <div class="left">店长姓名</div>
        <div class="right">王强</div>
      </div>
      <div class="item flexBetween">
        <div class="left">手机号</div>
        <div class="right blue">王强</div>
      </div>
      <div class="item flexBetween">
        <div class="left">店铺名称</div>
        <div class="right">王强</div>
      </div>
      <div class="item flexBetween">
        <div class="left">店铺类型</div>
        <div class="right">王强</div>
      </div>
      <div class="item flexBetween">
        <div class="left">店铺地址</div>
        <div class="right">王强</div>
      </div>
    </div>
  </div>
</template>

<script>
  import navBar from "../../components/navBar";
  export default {
    name: "shopInfo",
    components:{
      navBar
    },
    data(){
      return{
        topTitle:''
      }
    }
  }
</script>

<style scoped lang="less">
  .infoBox{
    margin-top: 6px;
    padding: 0 14px;
    background: #fff;
    .item{
      line-height: 44px;
      border-bottom: 1px solid #F5f5f5;
      .left{
        font-weight: bold;
      }
      .blue{
        color: #687BFF;
      }
    }
  }
</style>
